module.exports = __webpack_public_path__ + "img/negative-logo.a651b146.svg";